"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LAYOUT_TYPES = void 0;
const LAYOUT_TYPES = exports.LAYOUT_TYPES = ['horizontal', 'vertical'];